import axios from "axios";

const API = axios.create({ baseURL: process.env.REACT_APP_BASE_URL })
// const API = axios.create({ baseURL: "http://192.168.29.181" }) // Incorrect URL

export const addScreenAPI = (formData, headers) => API.post(`/admin/onboarding-screen/add`, formData, headers)
export const onboardingScreenAPI = (headers) => API.get(`/admin/onboarding-screens`, headers)
export const singleOnboardingScreenAPI = (screen_id, headers) => API.get(`/admin/onboarding-screen/${screen_id}`, headers)
export const updateOnboardingScreenAPI = (screen_id, formData, headers) => API.post(`/admin/onboarding-screen/update/${screen_id}`, formData, headers)
export const deleteOnboardingScreenAPI = (screen_id, headers) => API.delete(`/admin/onboarding-screen/delete/${screen_id}`, headers)